import React, { useState, useEffect } from "react";
import { Button, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import MainLayout from "../../../layouts/MainLayout";
import { getMyActivity } from "../../../api/actions/Me";

import CheckmarkCircle from "react-ionicons/lib/CheckmarkCircle";
import EllipseOutline from "react-ionicons/lib/EllipseOutline";
import languageManager from "../../../helpers/Language";
import DriveActivityList from "../../../components/DriveActivity/ActivityListGroup";

import ServerPicOneURL from "../../../assets/img/draw-kit/server_pic_1.svg";
import { connect } from "react-redux";
import { getMyOTPStatus } from "../../../api/actions/Session";
import SkeletonBox from "../../../components/SkeletonBox/SkeletonBox";
import ImagePreview from "../../../components/DocumentPreview/ImagePreview";
import API from "../../../api/app.api";
import UserAnalytic from "../../../helpers/UserAnalytic";

export const DFLT_ICO_PROPS = {
  height: "24px",
  width: "24px",
  color: "inherit",
};

export const TODO_ICO_PROPS = {
  height: "32px",
  width: "32px",
  color: "inherit",
};

const API_URL = process.env.REACT_APP_PORTAL_API;

const AccountSetupItem = ({ title, isComplete, shimmer }) => {
  let completedStatusIcon = (
    <SkeletonBox className="rounded" style={{ minWidth: 30, height: 32 }} />
  );
  if (!shimmer) {
    completedStatusIcon = isComplete ? (
      <CheckmarkCircle {...TODO_ICO_PROPS} />
    ) : (
      <EllipseOutline {...TODO_ICO_PROPS} />
    );
  }
  return (
    <ListGroup.Item>
      <Row className="account-setup-item">
        <Col
          style={{ maxWidth: "40px" }}
          className={[
            "task-status d-flex align-items-center justify-content-center",
            isComplete ? "completed" : "pending",
          ]}
        >
          {completedStatusIcon}
        </Col>
        <Col style={{ paddingTop: "4px" }} className="ps-1">
          <span className="h5">{title || "-"}</span>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

export const MEM_DOCUMENTS_DATA = {};

const Homepage = ({ userProfile, session }) => {
  const statsBookImgURL = `${API_URL}/api/v1/federated/cold-document/statbook/0?token=${session.token}`;
  const surveyImgURL = `${API_URL}/api/v1/federated/cold-document/survey/0?token=${session.token}`;
  const [initialized, setInitialized] = useState(false);
  const [hasOTPEnabled, setOTPStatus] = useState(null);
  const [myDriveActivity, setMyDriveActivity] = useState(null);
  const [coldDocumentImages, setColdDocuments] = useState(null);
  const u = userProfile || {};
  const fullUserName = `${u.firstname} ${u.lastname}`;

  const handleRefreshMyActivity = async () => {
    try {
      setMyDriveActivity(null);
      const res = await getMyActivity();
      const d = Array.isArray(res.data) ? res.data : [];
      const driveActivity = d.filter(
        (af) => af.activityFeed.origin === "drive"
      );
      setMyDriveActivity(driveActivity);
    } catch (err) {
      console.log(err);
    }
  };
  const handleRefreshOTPStatus = async () => {
    const res = await getMyOTPStatus();
    setOTPStatus(res.data);
  };

  const handleGetImagesData = async (documentName) => {
    if (!MEM_DOCUMENTS_DATA[documentName]) {
      try {
        const res = await API.get(
          "/api/v1/federated/cold-document/" + documentName
        );
        const data = (res.data || {}).data;
        const imgNumber = data.count || 0;
        var idx = -1;
        const images = [];
        while (++idx < imgNumber) {
          images.push(
            API_URL +
              "/api/v1/federated/cold-document/" +
              documentName +
              "/" +
              idx
          );
        }
        MEM_DOCUMENTS_DATA[documentName] = images;
      } catch (e) {
        console.error(e);
      }
    }
    setColdDocuments(MEM_DOCUMENTS_DATA[documentName]);
    UserAnalytic.event({
      category: "marketing_book",
      action: 'Open "' + documentName + '"',
    });
  };

  useEffect(() => {
    const init = () => {
      handleRefreshMyActivity();
      handleRefreshOTPStatus();
      setInitialized(true);
    };

    init();
  }, []);

  console.log("PROFILE", userProfile);
  console.log("SESSION", session);

  return (
    <MainLayout pageTitle={languageManager.T("HOMEPAGE_TITLE_HOME")}>
      <Container>
        <h1>{languageManager.T("HOMEPAGE_LABEL_WELCOME")}</h1>
        <h2 className="text-muted">{fullUserName}</h2>
        <Row>
          <Col lg={6} style={{ marginTop: "20px", textAlign: "center" }}>
            <img src={ServerPicOneURL} height={350} />
          </Col>
        </Row>
        <Row>
          <Col lg={6} style={{ marginTop: "20px" }}>
            {/** disabled until drive features are released **/}
            {/**
                        <h4 onClick={handleRefreshMyActivity}>
                        {languageManager.T('HOMEPAGE_LABEL_DOCUMENTS')} <span className="text-muted h6">- {languageManager.T('HOMEPAGE_LABEL_DOCUMENTS_RECENT_TEXT')}</span>
                        </h4>
                        <DriveActivityList
                            className="shadow-sm"
                            items={myDriveActivity}
                        />
                    **/}
          </Col>
          {userProfile.isBusinessOwner && (
            <Col lg={6}>
              <Row className="">
                <div className="h4" style={{ marginTop: "20px" }}>
                  {languageManager.T("HOMEPAGE_TITLE_PROMO_HEADLINE")}
                </div>
                <Col>
                  <div className="h5">
                    {languageManager.T("HOMEPAGE_TITLE_PROMO_STATS_BOOKS")}
                  </div>
                  <Card className="shadow-sm pt-3">
                    <Card.Img
                      src={statsBookImgURL}
                      style={{
                        objectFit: "contain",
                        maxHeight: 320,
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0,
                      }}
                    />
                    <Card.Body>
                      <Button
                        onClick={(e) => {
                          e.target.blur();
                          handleGetImagesData("statbook");
                        }}
                        className="btn btn-primary w-100"
                      >
                        View document
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <div className="h5">
                    {languageManager.T("HOMEPAGE_TITLE_PROMO_SALARY_SURVEY")}
                  </div>
                  <Card className="shadow-sm pt-3">
                    <Card.Img
                      src={surveyImgURL}
                      style={{
                        objectFit: "contain",
                        maxHeight: 320,
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0,
                      }}
                    />
                    <Card.Body>
                      <Button
                        onClick={(e) => {
                          e.target.blur();
                          handleGetImagesData("survey");
                        }}
                        className="btn btn-primary w-100"
                      >
                        View document
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Container>
      {coldDocumentImages && (
        <ImagePreview
          images={coldDocumentImages}
          onClose={() => setColdDocuments(null)}
        />
      )}
    </MainLayout>
  );
};

const mapStateToProps = (appState) => ({
  userProfile: appState.userProfile,
  session: appState.session,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
